/* Easypick conversion blocks. Vanilla, no dependencies, defer-loaded. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- ladder */
  function initLadder(root) {
    var radios = root.querySelectorAll('[data-ydc-tier]');
    if (!radios.length || root.dataset.ladderInitialized) return;
    root.dataset.ladderInitialized = 'true';
    var sizeFields = root.querySelectorAll('[data-item-size-field]');
    var sizeSelect = root.querySelector('[data-item-size]');
    var form = sizeSelect && document.getElementById(sizeSelect.getAttribute('form'));
    if (form) bindPackCheckout(form);

    var section = root.closest('.shopify-section') || document;

    function quantityField() {
      return (
        root.querySelector('[data-ydc-qty-proxy]') ||
        section.querySelector('.quantity__input') ||
        section.querySelector('input[name="quantity"]')
      );
    }

    function apply(radio) {
      // Variant mode: point the form at the chosen variant. The theme's own
      // picker is hidden, so this input is what actually gets submitted — and
      // what Fastrr reads. Quantity stays 1 because the pack IS the variant.
      var variantId = radio.getAttribute('data-ydc-variant');
      var field = quantityField();
      if (variantId) {
        section.querySelectorAll('input[name="id"]').forEach(function (input) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        if (field) field.value = 1;
      } else if (field) {
        field.value = radio.value;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }

      sizeFields.forEach(function (field) {
        var active = Number(field.dataset.itemSizeField) <= Number(radio.dataset.itemCount || 1);
        field.hidden = !active;
        var select = field.querySelector('select');
        select.disabled = !active;
        select.required = active;
      });
      var total = radio.getAttribute('data-total-formatted') || '';
      var was = radio.getAttribute('data-was-formatted') || '';

      var stickyPrice =
        section.querySelector('[data-ydc-sticky-price]') ||
        document.querySelector('[data-ydc-sticky-price]');
      if (stickyPrice) {
        // textContent, never innerHTML: the value is merchant data but this
        // keeps the sink safe regardless of what lands in the setting.
        stickyPrice.textContent = total;
      }

      // The headline price must show the selected pack's total. Leaving it on
      // the single-unit price contradicts the ladder at the point of purchase.
      syncHeadlinePrice(total, was);

      root.querySelectorAll('.ydc-tier').forEach(function (el) {
        el.classList.toggle('is-selected', el.contains(radio));
      });
    }

    function syncHeadlinePrice(total, was) {
      if (!total) return;

      // A product section can carry more than one price readout — the headline
      // and the theme's own sticky bar. Updating only the first leaves the
      // sticky bar quoting the single-unit price while a bundle is selected.
      section.querySelectorAll('.price').forEach(function (price) {
        price.classList.toggle('price--on-sale', !!was);

        // Dawn renders the live price in .price-item--sale when on sale, and in
        // .price__regular otherwise. Update whichever is present.
        var sale = price.querySelector('.price-item--sale');
        if (sale) {
          sale.textContent = total;
        } else {
          var regular = price.querySelector('.price__regular .price-item--regular');
          if (regular) regular.textContent = total;
        }

        var struck = price.querySelector('.price__sale s.price-item--regular');
        if (struck) {
          struck.textContent = was;
          struck.hidden = !was;
        }
      });

      // Themes that print the price inside the Add to cart label (Shrine Pro's
      // .main-atc-price) keep their own separator around it, so replace just
      // the money token rather than the whole string.
      section.querySelectorAll('[class*="atc-price"]').forEach(function (el) {
        setMoneyToken(el, total);
      });
    }

    function setMoneyToken(el, money) {
      var tpl = el.getAttribute('data-ydc-money-tpl');
      if (tpl === null) {
        tpl = el.textContent;
        el.setAttribute('data-ydc-money-tpl', tpl);
      }
      el.textContent = tpl.replace(/[^\s\d]{0,3}\s?\d[\d.,]*/, money);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(radio);
      });
    });

    // A ?variant= link (shared URL, Meta catalog, email) must win over the
    // merchant's default tier, or the page shows one pack selected and another
    // pack's price. Without that param the form just holds Shopify's first
    // variant, which is not a choice — so the default tier stands.
    if (/[?&]variant=/.test(window.location.search)) {
      var current = section.querySelector('input[name="id"]');
      var preselected = current && root.querySelector('[data-ydc-variant="' + current.value + '"]');
      if (preselected) preselected.checked = true;
    }

    var checked = root.querySelector('[data-ydc-tier]:checked');
    if (checked) apply(checked);
  }

  // Size properties use standard Shopify form fields. The theme's ProductForm
  // remains responsible for adding, errors, cart sections and drawer updates.
  function bindPackCheckout(form) {
    var productForm = form.closest('product-form');
    if (!productForm || productForm.dataset.packCheckoutBound) return;
    productForm.dataset.packCheckoutBound = 'true';
    var pending = false;
    var checkoutButton;
    function validate() { return form.reportValidity(); }
    function reset() {
      pending = false;
      if (checkoutButton) checkoutButton.removeAttribute('aria-busy');
      delete productForm.dataset.checkoutIntent;
    }
    productForm.addEventListener('click', function (event) {
      var button = event.target.closest('.sr-headless-checkout');
      if (!button || !productForm.contains(button)) return;
      event.preventDefault();event.stopImmediatePropagation();
      if (pending || !validate()) return;
      if (!window.HeadlessCheckout || typeof window.HeadlessCheckout.checkout !== 'function') {
        productForm.handleErrorMessage('Secure checkout is loading. Please try again.');
        return;
      }
      var addButton = form.querySelector('[name="add"]');
      if (!addButton || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') return;
      pending = true;checkoutButton = button;button.setAttribute('aria-busy','true');
      productForm.dataset.checkoutIntent = 'buy-now';
      form.requestSubmit(addButton);
    }, true);
    productForm.addEventListener('product:added', function (event) {
      var buyNow = pending && event.detail.checkoutIntent === 'buy-now';
      reset();
      if (buyNow) window.HeadlessCheckout.checkout();
    });
    productForm.addEventListener('product:error', reset);
  }

  /* ----------------------------------------------------------------- timer */
  if (!customElements.get('ydc-timer')) {
    customElements.define(
      'ydc-timer',
      class extends HTMLElement {
        connectedCallback() {
          var minutes = parseInt(this.dataset.minutes, 10) || 15;
          var key = this.dataset.key || 'ydc-timer';
          this.mm = this.querySelector('[data-ydc-mm]');
          this.ss = this.querySelector('[data-ydc-ss]');

          var stored = null;
          try {
            stored = sessionStorage.getItem(key);
          } catch (e) {
            /* private mode */
          }

          var deadline = stored ? parseInt(stored, 10) : NaN;
          if (!deadline || isNaN(deadline) || deadline < Date.now()) {
            deadline = Date.now() + minutes * 60000;
            try {
              sessionStorage.setItem(key, String(deadline));
            } catch (e) {
              /* ignore */
            }
          }

          this.deadline = deadline;
          this.tick();
          this.interval = setInterval(this.tick.bind(this), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }

        tick() {
          var left = Math.max(0, this.deadline - Date.now());
          var total = Math.floor(left / 1000);
          var m = Math.floor(total / 60);
          var s = total % 60;
          if (this.mm) this.mm.textContent = String(m).padStart(2, '0');
          if (this.ss) this.ss.textContent = String(s).padStart(2, '0');
          if (left <= 0) {
            clearInterval(this.interval);
            this.classList.add('ydc-timer--expired');
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------ sticky atc */
  if (!customElements.get('ydc-sticky-atc')) {
    customElements.define(
      'ydc-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          var formId = this.dataset.form;

          // Dawn's scroll animations leave a `transform` on the product info
          // wrapper. Any transform makes that element the containing block, so
          // `position: fixed` anchors to it instead of the viewport and the bar
          // scrolls away with the page. Re-parenting to <body> is the only
          // reliable escape. The submit button uses the HTML5 `form` attribute,
          // so it keeps working from anywhere in the document.
          if (this.parentElement !== document.body) {
            var stale = document.querySelector(
              'body > ydc-sticky-atc[data-form="' + (formId || '') + '"]'
            );
            if (stale && stale !== this) stale.remove();
            document.body.appendChild(this);
            return; // re-entry runs the rest
          }

          var form = formId ? document.getElementById(formId) : null;
          var anchor = form
            ? form.querySelector('[name="add"]') || form
            : document.querySelector('.product-form__buttons');

          if (!anchor || !('IntersectionObserver' in window)) {
            this.classList.add('is-visible');
            return;
          }

          var self = this;
          this.observer = new IntersectionObserver(
            function (entries) {
              var e = entries[0];
              // Only show once the buy button has scrolled ABOVE the viewport.
              // Showing it while the button is still below just covers the page
              // with a duplicate CTA the shopper hasn't reached yet.
              var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
              self.classList.toggle('is-visible', scrolledPast);
            },
            { rootMargin: '0px 0px -40px 0px' }
          );
          this.observer.observe(anchor);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  /* --------------------------------------------------------------- booting */
  function initStockTimer(node) {
    if (node.dataset.ydcStockTimerBound) return;
    node.dataset.ydcStockTimerBound = '1';

    var mins = parseInt(node.getAttribute('data-ydc-minutes'), 10) || 0;
    if (!mins) return;
    var ends = Date.now() + mins * 60000;

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function tick() {
      // Re-query: the theme re-renders product info and detaches the node.
      var clock = node.querySelector('[data-ydc-stock-clock]');
      if (!clock) return;
      var left = Math.max(0, ends - Date.now());
      var s = Math.floor(left / 1000);
      clock.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (left <= 0 && timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    var timer = setInterval(tick, 1000);
    tick();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.ydc-ladder').forEach(initLadder);
    (scope || document).querySelectorAll('[data-ydc-stock-timer]').forEach(initStockTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // The theme editor and Dawn's variant change both re-render product info,
  // which throws away previously captured element references.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('ydc:reinit', function (e) {
    boot(e.target);
  });
})();
